//class ServiceStatus {
//     DRAFT, ACTIVE, ACTIVE_NOT_BOOKABLE;
export var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["DRAFT"] = "DRAFT";
    ServiceStatus["ACTIVE"] = "ACTIVE";
    ServiceStatus["ACTIVE_NOT_BOOKABLE"] = "ACTIVE_NOT_BOOKABLE";
})(ServiceStatus || (ServiceStatus = {}));
